/* eslint-disable */
var Cookies = require('cookies-js');
var http = require('./http');
var domutils = require('./domutils');
var makeElt = domutils.makeElt;

require('./emile.min.js');

module.exports = function touchMenu(){

  var elt = $('#nav');
  var content= $('#nav ul.nav');
  var toolbar = $('<div class="toolbar"><a class="btn btn_previous" title="Previous"><i class="icon-chevron-left"></i></a><span class="header"></span><span class="breadcrumb"></span></div>');
  var current = $('#nav ul.nav');
  var previous;
  var listCurrent;
  var histo = [];
  var mbFOV = false;
  var mbUI = false;
  var mbUIObj = null;
  var contextData;


  window.DR.pubsub.on('resize', checkDevice);

  checkDevice($(window).width());

  function loadChild(controler, callback) {
    var childURL = controler.attr('data-rel');

    if (controler.attr('data-init') !== 'true' && childURL !== '') {
      controler.attr('data-init', 'true');
      controler.addClass('nav_loading');
      $.ajax({
        url: childURL,
        type: 'json',
        success: function(resp){
          $(resp.content).insertAfter(controler);
          $(resp.content).find('ul').each(function(){
            $(this).css({ right: '-'+elt.width()+'px' });
          });
          controler.removeClass('nav_loading');
          if (typeof callback === 'function')
            callback(controler);
        }
      });
    }
  }

  function updateNav() {
    var $i = 0;
    histo = [];
    previous = $(current.parents('ul')[0]);

    if (!elt.find('.toolbar').length) {
      toolbar.insertBefore(content);
    }
    else {
      toolbar.show();
    }

    toolbar.find('span').empty();
    content.css({height: current.height()+'px'});

    $(content.find('a.active')).each(function(){ histo.push($(this)); });

    if (histo.length > 1) {

      if (!listCurrent) {
        listCurrent = $('<a class="btn btn_list" title="List products"><i class="icon-list icon-large"></i></a>').appendTo(toolbar);
        listCurrent.click(function(){
          contextData.nav_list_products = 'Yes';
          Cookies.set('s_contextData', JSON.stringify(contextData));
        });
      } else {
        listCurrent = toolbar.find('a.btn_list');
      }
      listCurrent.show().attr('href', histo.slice(-1)[0].attr('href'));

    } else {
      toolbar.find('a.btn_home').hide();
      toolbar.find('a.btn_list').hide();
    }

    $(histo).each(function(){
      $i++;
      var origin = $(this);
      var step = ( $i != histo.length ) ? origin[0].cloneNode(true) : $('<span class="current">'+origin.text()+'</span>');
      $(step).appendTo(toolbar.find('.breadcrumb'));
      toolbar.find('.header').text($(step).text());
    });

    toolbar
      .find('a.btn_previous').unbind('click')
      .click(function(e){
        e.stopPropagation();
        scrollTop();
        if ( !current.hasClass('nav') ) {
          histo = histo.slice(0, -1);
          current.removeClass('active');
          window.emile(current[0], 'right: -100%', {
            duration: 300,
            after: function(){
              current = previous;
              current.addClass('active').find('a.active').removeClass('active');
              content.css({height: current.height()+'px'});
              if (current.hasClass('nav')) { toolbar.hide(); content.css({height: 'auto'}); }
              else { updateNav(); }
            }
          });
        }
      });
  }

  function slideNav(controler) {
    var container = controler.next('ul');
    current.find('a').unbind('click').click(function(e){
      e.preventDefault(); });

    if ( container.length ) {
      current = container;
      previous = $(controler.parents('ul')[0]);
      controler.addClass('active');
      elt.find('.nav ul').each(function(){
        if ($(this) != current) $(this).removeClass('active');
      });
      current.addClass('active').css({right: '-'+elt.width()+'px'});
      window.emile(current[0], 'right: 0;margin-left:-1px', {
        duration: 300,
        after: bindSlide
      });
      updateNav();
      scrollTop();
    }
  }

  function setTagging(el) {
    contextData = {
      nav_type: 'Touch menu',
      nav_dept: $(el).closest('[data-level="1"]').find('> a').text(),
      nav_level: $(el).parent().attr('data-level'),
      nav_name: $(el).text(),
      nav_list_products: 'No'
    };

    Cookies.set('s_contextData', JSON.stringify(contextData));
  }

  function bindSlide(){
    elt.find('> ul a').each(function(i){
      var controler = $(this);
      controler.unbind('mouseenter');
      controler.unbind('click');
      controler.click(function(e){
        setTagging(this);
        if (!!controler.attr('data-rel') && controler.attr('data-init') != 'true') {
          e.preventDefault();
          loadChild(controler, function(){
            slideNav(controler);
            bindSlide();
          });
        }
        else {
          if (controler.next('ul').length ) {
            e.preventDefault();
            controler.next().find('li a').each(function(i){
              setTagging(this);
            });
            slideNav(controler);
          }
        }

      });
    });
  }

  function scrollTop() {
    if ( $(window).width() < 600 ) window.scrollTo(0, elt.offset().top);
  }

  // Build Mobile navigation
  function build(){
    // Nav toggle
    elt.find('.nav').css({height:'auto'});
    // Sliding nav
    bindSlide();
  }

  // Destroy Mobile navigation
  function destroy(){
    histo = [];
    toolbar.remove();
    elt.insertAfter('#header');
    content.css({height: 'auto'});
    content.find('ul').removeAttr('style');
    content.find('a').unbind('click').removeClass('active');
  }

  // Rebuild Mobile navigation
  function rebuild(){
    if (!$('#page').is(':hidden'))
      elt.find('.nav').css({height: current.height() + 'px'});
  }

  function checkDevice(width){
    var width = width || $(window).width();
    mbFOV = ( width < 1025 ) ? true : false;
    if ( mbFOV && !mbUI ) { build(); mbUI = true; }
    else if ( !mbFOV && mbUI ) { destroy(); mbUI = false; }
    else if ( mbFOV && mbUI ) { rebuild(); }
  }

  var b = $('body');
  var w = $(window);
  var visible = false;
  var nav = document.getElementById('nav');

  //toggle touch menu
  function toggle(){
    if (!b.hasClass('navActived')) {
      show();
    } else {
      hide();
    }
  }

  //show touch menu
  function show(){
    if (!visible) {
      nav.style.display = 'block';
      visible = true;
    }
    window.emile($('#wrapper')[0], 'left: 16rem', { duration: 200 });
    if (!b.hasClass('oldAndroid')) {
      window.emile($('#header')[0], 'left: 16rem', { duration: 200, after: function(){
        nav.style.display = 'block'; b.addClass('navActived');
      } });
    } else {
      b.addClass('navActived');
      nav.style.display = 'block';
    }
  }

  //hide touch menu
  function hide(){
    window.emile($('#wrapper')[0], 'left: 0', { duration: 200 });
    if ( !b.hasClass('oldAndroid') ) {
      window.emile($('#header')[0], 'left: 0', {
        duration: 200,
        after: function(){
          b.removeClass('navActived');
          nav.style.display = 'none';
        }
      });
    } else {
      b.removeClass('navActived');
      nav.style.display = 'none';
    }
  }

  $(document).on('click', 'a[href="#nav"]', function(e){
    e.preventDefault();
    e.stopPropagation();
    toggle();
  });

  $('#nav').delegate('*', 'click', function(e){
    e.stopPropagation();
  });

  // Search form toggle
  $(document).on('click', 'a[href="#searchForm"]', function(e){
    e.preventDefault();
    if (b.hasClass('searchExpanded')){
      b.removeClass('searchExpanded');
      $('#search').blur();
    } else {
      $('#search').focus();
      b.addClass('searchExpanded');
    }
  });

  document.ontouchmove = function(e) {
    // touchMove should be prevented only when user tries to scroll out of menu.
    // Main menu itself allows scrolling.
    if(!e.target.closest('#nav')) {
      if (b.hasClass('navActived')) e.preventDefault();
    }
  };

  $('#content').click(function(){
    if (b.hasClass('navActived')) hide();
  });

  if ($('#nav ul').length) {
    $('#nav ul')[0].ontouchmove = function(e){
      if ($(this).height() > $(window).height) e.stopPropagation();
    };
  }
};
